module.exports = __webpack_public_path__ + "img/resume-style-1.af37e09d.jpeg";